import { Box, FormControlLabel, List, Switch } from '@mui/material';
import { FC, useState } from 'react';
import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';
import { Loader, Page, PageTitleWithBack } from '../../../../../components';
import {
  getNeighborhoodSeriesColorExclusionOptions,
  getNeighborhoodSeriesSelectedColorExclusionOptions
} from '../../../../../fetch';
import { IColorExclusions } from '../../../../../models';

import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import { ExcludedColorOptionList } from './excluded-colors-list';

export const ExcludedColorsOptionsPage: FC = () => {
  const classes = useStyles();
  const { neighborhoodId, selectedSeriesId }: { neighborhoodId: string; selectedSeriesId: string } =
    useParams();

  const [onlyFiltered, setOnlyFiltered] = useState<boolean>(false);
  const {
    isLoading: isLoadingSeriesColorExclusionOptions,
    data: neighborhoodsSeriesColorExclusionOptions
  } = useQuery<IColorExclusions[], Error>(
    ['neighborhoodsSeriesExcludedColorOptions'],
    () => getNeighborhoodSeriesColorExclusionOptions(),
    {
      onSuccess: data => {},
      notifyOnChangeProps: 'tracked'
    }
  );

  const {
    data: neighborhoodsSeriesSelectedColorExclusionOptions,
    refetch: refetchNeighborhoodsSeriesSelectedColorExclusionOptions
  } = useQuery<number[], Error>(
    ['neighborhoodSeriesSelectedExclusionOptions'],
    () => getNeighborhoodSeriesSelectedColorExclusionOptions(neighborhoodId, selectedSeriesId),
    {
      onSuccess: data => {},
      notifyOnChangeProps: 'tracked'
    }
  );

  return (
    <Page title="Options - Excluded Color Options">
      <PageTitleWithBack
        title="Excluded Color Options"
        backText={'Neighborhood Options'}
        backUrl={`/development/neighborhoods/${neighborhoodId}/options/${selectedSeriesId}`}
        subTitle={'Please indicate whether a color option is excluded from this Series'}
        additionalHeaderContent={
          <FormControlLabel
            control={
              <Switch
                color="primary"
                checked={onlyFiltered}
                id="filtered-nonfiltered"
                onChange={(e: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
                  setOnlyFiltered(prev => !prev);
                }}
              />
            }
            label="Excluded"
          />
        }
      />
      {isLoadingSeriesColorExclusionOptions && <Loader type="fullscreen" position="centered" />}
      {!isLoadingSeriesColorExclusionOptions && (
        <>
          <Box
            margin={{
              xs: '0 0 0 0',
              sm: '0 0 0 1rem'
            }}
          >
            <List component="div" aria-labelledby="nested-list-subheader" className={classes.list}>
              {neighborhoodsSeriesColorExclusionOptions &&
                neighborhoodsSeriesColorExclusionOptions
                  .filter(colorOption => {
                    if (onlyFiltered) {
                      return neighborhoodsSeriesSelectedColorExclusionOptions.includes(
                        colorOption.colorSchemeID
                      );
                    }
                    return true;
                  })
                  .map(colorOption => (
                    // <div>{colorOption.code}</div>
                    <ExcludedColorOptionList
                      key={`${colorOption.code}`}
                      colorOption={colorOption}
                      selections={neighborhoodsSeriesSelectedColorExclusionOptions}
                      refetch={refetchNeighborhoodsSeriesSelectedColorExclusionOptions}
                    />
                  ))}
            </List>
          </Box>
        </>
      )}
    </Page>
  );
};
const useStyles = makeStyles((theme: Theme) => ({
  header: {
    marginTop: theme.spacing(1)
  },
  list: {
    maxHeight: `35rem`,
    overflow: 'auto',
    margin: theme.spacing(1, 0)
  }
}));
